import { GitMerge } from '@orgus/ui/icons';
import { LandingSettings } from '../../landing/LandingSettings.tsx';
import type { SettingsSection } from '../registry.ts';

/** The landing queue's own settings, beside policy's Landing and freezes (order 32). */
const section: SettingsSection = {
  id: 'landing-queue',
  title: 'Landing queue',
  description: 'How each project verifies, lands and deploys.',
  order: 20,
  group: 'delivery',
  keywords: ['landing', 'verify', 'deploy', 'queue', 'environments', 'merge'],
  icon: GitMerge,
  Component: LandingSettings,
};
export default section;
